// @flow
import React, { Fragment, useState, useContext } from 'react';
import Sticky from 'react-stickynode';

import { useRouter } from 'Client/router/useRouter';
import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { type BadgeProps } from 'Components/frameworks/badge/Badge';
import { type BlockLinkProps } from 'Components/frameworks/block-link/BlockLink';
import { type ButtonProps } from 'Components/frameworks/button/Button';
import { Icon } from 'Components/frameworks/icon/Icon';
import { type PriceProps } from 'Components/frameworks/price/Price';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { ICONS } from 'Components/utils/icon/icons';
import { PriceTicketLarge } from 'Components/widgets/price-ticket-large/PriceTicketLarge';
import { PriceTicketNarrow } from 'Components/widgets/price-ticket-narrow/PriceTicketNarrow';
import { isSeller } from 'Utils/seller/sellerUtils';
import ReactAppContext from 'Context/ReactAppContext';
import { t } from 'Src/i18n';

export type PriceTicketInfo = {
  iconName?: string | null,
  label?: string,
};
type PriceTicketStaticPrice = {
  price: string,
  amount: string,
};

export type PriceTicketItem = { iconName: string, description: string, label?: string };

export type PriceTicketContentProps = {|
  badgeIcon?: BadgeProps,
  blockLink?: BlockLinkProps,
  button?: ButtonProps,
  className?: string,
  closeLabel?: string,
  collapseLabel?: string,
  expandLabel?: string,
  hasCallCenter?: boolean,
  info?: PriceTicketInfo,
  isLoading?: boolean,
  items?: Array<PriceTicketItem>,
  minHeight?: string,
  price?: PriceProps,
  staticPrice?: PriceTicketStaticPrice,
  subtitle?: string,
  title?: string,
  travelAdvisorConfig?: CMSTravelAdvisor,
|};

export const PriceTicketContentWrapper = (props: PriceTicketContentProps) => {
  const appContext = useContext(ReactAppContext);
  const { history } = useRouter<PageWithLinesUrlParams, ProductQueryParams>();
  const { isDesktop } = useContext(ResponsiveContext);
  const [isSticky, setIsSticky] = useState(false);

  const onStateChange = (status: *) => {
    setIsSticky(status.status !== Sticky.STATUS_ORIGINAL);
  };

  return (
    <Fragment>
      <SiteContainer>
        {isSeller(appContext) ? (
          <button
            className="flex items-center mb-3 text-turquoise"
            data-testid="PriceTicketBackToSearch"
            onClick={history.back}
            type="button"
          >
            <Icon width="0.9rem" className="-scale-x-1 mr-1" name={ICONS.BOLDER_ARROW_FORTH} />
            {t('common.comparator.backToSearch')}
          </button>
        ) : null}
      </SiteContainer>
      <Sticky
        activeClass="sticky-bottom"
        releasedClass="sticky-bottom-released"
        onStateChange={onStateChange}
        bottomBoundary=".PriceTicket-sticky-beacon"
      >
        {isDesktop ? (
          <PriceTicketLarge {...props} isLite={isSticky} />
        ) : (
          <PriceTicketNarrow {...props} isLite={isSticky} />
        )}
      </Sticky>
    </Fragment>
  );
};
